import { render, staticRenderFns } from "./PopupChangeInvoice.vue?vue&type=template&id=a80f8910&scoped=true&"
import script from "./PopupChangeInvoice.vue?vue&type=script&lang=js&"
export * from "./PopupChangeInvoice.vue?vue&type=script&lang=js&"
import style0 from "./PopupChangeInvoice.vue?vue&type=style&index=0&id=a80f8910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80f8910",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VDialog,VRow})
